import { Grid, Card, CardContent, Typography, Stack, CardActions, Button, IconButton, SpeedDial } from '@mui/material';
import SmartphoneIcon from '@mui/icons-material/Smartphone';
import { blueGrey } from '@mui/material/colors';
import EventIcon from '@mui/icons-material/Event';
import { EditCalendar, Delete, ReadMore, EventSeat, Add, Mail, CurrencyRupee } from '@mui/icons-material'
import ScrollDialog from 'components/ScrollDialog';
import { useCallback, useState } from 'react';

const BookingsMobileView = ({bookings=[], addBooking, editBooking, onDeleteBtnClick, permissions={}, checkInInmate}) => {
  const { isAddBookingsAllowed, isEditBookingsAllowed } = permissions;
  const [openBookingDetailsModal, setOpenBookingDetailsModal] = useState(false);
  const [bookingData, setBookingData] = useState(null);

  const onModalClose = useCallback(() => {
    setOpenBookingDetailsModal(false);
    setTimeout(() => setBookingData(null), 400)
  }, []);

  const showBookingDetails = useCallback((data) => {
    setBookingData(data);
    setOpenBookingDetailsModal(true);
  }, []);


  return (
    <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} spacing={2} mb={5}>
      {bookings.map((bookingInfo) => 
        <Grid item xs={12} sm={6} md={6} lg={6} key={bookingInfo.id}>
          <Card>
            <CardContent>
              <Typography sx={{ fontSize: 12 }} color="grey">
                Booked on {bookingInfo.bookingDate}
              </Typography>
              <Typography variant="h6" component="div" fontSize={'1rem'} gutterBottom>
                {bookingInfo.name}
              </Typography>
              <Stack direction="row" alignItems="center" gap={.5}>
                <SmartphoneIcon sx={{fontSize: '1rem', color: blueGrey[200]}} />
                <Typography sx={{ fontSize: 14.5, color: blueGrey[700], fontWeight: 500 }} >
                  {bookingInfo.mobileNumber}
                </Typography>
              </Stack>
              <Stack direction="row" alignItems="center" gap={.5}>
                <EventIcon sx={{fontSize: '1rem', color: blueGrey[200]}} />
                <Typography sx={{ fontSize: 14.5, color: blueGrey[700] }} >
                  Joining on <strong style={{fontWeight: 500}}>{bookingInfo.joiningDate}</strong>
                </Typography>
              </Stack>
            </CardContent>
            <CardActions>
              <Stack direction="row" justifyContent="space-around" gap={2} sx={{flexFlow: "wrap"}} width='100%' mb={1}>
                {isEditBookingsAllowed ? (
                  <>
                    <IconButton aria-label="delete"  onClick={() => editBooking(bookingInfo)} >
                      <EditCalendar fontSize="inherit" color="warning" />
                    </IconButton>
                    <IconButton aria-label="delete"onClick={() => onDeleteBtnClick(bookingInfo.id)}>
                      <Delete fontSize="inherit" color="error" />
                    </IconButton>
                  </>
                ) : null}
                <IconButton aria-label="delete" onClick={()=>showBookingDetails(bookingInfo)}>
                  <ReadMore fontSize="inherit" color="info" />
                </IconButton>
                
                <Button 
                  startIcon={<EventSeat />} 
                  size="small" 
                  sx={{fontSize: 13, fontWeight: 400}} 
                  variant="tonal" 
                  color="primary"
                  onClick={() => checkInInmate(bookingInfo)}
                >
                  Check-In
                </Button> 
              </Stack>
             
            </CardActions>
          </Card>
        </Grid>
      )}
      {isAddBookingsAllowed ? (
        <SpeedDial
          ariaLabel="Add Booking"
          sx={{ position: 'fixed', bottom: 16, right: 32, display: {xs: 'block', md: 'none'} }}
          icon={<Add />}
          color='primary'
          onClick={addBooking}
          ></SpeedDial>
      ): null}
      <BookingDetailsModal openModal={openBookingDetailsModal} onModalClose={onModalClose} bookingData={bookingData} />
    </Grid>
  );
}
 
export default BookingsMobileView;

function BookingDetailsModal({openModal, onModalClose, bookingData={}}) {
  const { bookingDate, name, mobileNumber, joiningDate, email, bookingAmount, comments } = bookingData || {};

  return(
    <ScrollDialog 
      isFullScreen={false} 
      maxWidth="sm"  
      onModalClose={onModalClose} 
      open={openModal} 
      title="Booking Details"
      disableDialogActions={true}
      showCloseIcon={true}
    >
      <Card elevation={0} >
        <CardContent p={0}>
          <Typography sx={{ fontSize: 12 }} color="grey">
            Booked on {bookingDate}
          </Typography>
          <Typography variant="h6" component="div" fontSize={'1rem'} >
            {name}
          </Typography>
          <Typography sx={{ fontSize: 14.5, color: blueGrey[700] }} gutterBottom>
            Joining on <strong style={{fontWeight: 500}}>{joiningDate}</strong>
          </Typography>
          <Stack direction="row" alignItems="center" gap={.5} mb={.5}>
            <SmartphoneIcon sx={{fontSize: '1rem', color: blueGrey[200]}} />
            <Typography sx={{ fontSize: 14.5, color: blueGrey[700], fontWeight: 500 }} >
              {mobileNumber}
            </Typography>
          </Stack>
          {email ? (
            <Stack direction="row" alignItems="center" gap={.5} mb={.5}>
              <Mail sx={{fontSize: '1rem', color: blueGrey[200]}} />
              <Typography sx={{ fontSize: 14.5, color: blueGrey[700] }} >
                {email}
              </Typography>
            </Stack>
          ) : null}
          {bookingAmount ? (
            <Typography sx={{ fontSize: 14.5, color: blueGrey[700], }} gutterBottom>
              Booking amount paid:  <CurrencyRupee sx={{fontSize: 14, verticalAlign: 'middle'}} /><strong style={{fontWeight: 500}}>{parseFloat(bookingAmount).toFixed(2)}</strong>
            </Typography>
          ): null}
          {comments ? (
            <Typography sx={{ fontSize: 14.5, color: blueGrey[700], }} gutterBottom>
              {comments}
            </Typography>
          ): null}

        </CardContent>
      </Card>
    </ScrollDialog>
  )
}